import type { FreelancerBreakpointValues } from '@freelancer/ui/breakpoints';

export enum MapSize {
  DEFAULT = 'default',
  COMPACT = 'compact',
  INHERIT = 'inherit',
}

export interface MapBounds {
  topRight: MapCoordinates;
  bottomLeft: MapCoordinates;
}

export interface MapCoordinates {
  latitude: number;
  longitude: number;
}

export interface MapMarker {
  referenceId?: MarkerReferenceId;
  location: MapCoordinates;
  icon?: MarkerIcon;
  // Use when showing of tooltip is not triggered by clicking of map pin
  showTooltip?: boolean;
}

export type TooltipRef = MapMarker & {
  closeTooltip(): void;
  openTooltip(): void;
};

export interface MarkerIcon {
  url: string;
  scaledSize?: MarkerScale;
}

interface MarkerScale {
  height: number;
  width: number;
}

export interface DirectionsDetails {
  duration: number;
  distance: number;
}

export interface MarkerActivatedEventData {
  tooltip: TooltipRef;
  screenSize: FreelancerBreakpointValues;
}

export enum TooltipBehavior {
  HOVER = 'hover',
  CLICK = 'click',
}

export type MarkerReferenceId = string | number;
